import script from "./BoardCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardCard.vue?vue&type=script&setup=true&lang=ts"

import "./BoardCard.vue?vue&type=style&index=0&id=7ad7ef36&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad7ef36"]])

export default __exports__